import PlusCircle from './PlusCircle';
export * from './PlusCircle';
export default PlusCircle;
